/**
 * Product Card - Gestion des swatches et changement d'image
 */

// Ce script est inclus par plusieurs sections (featured-collection, related-products, etc.).
// Si plusieurs de ces sections apparaissent sur la même page, le fichier est chargé plusieurs
// fois : ce garde-fou évite la ré-exécution (et l'erreur "already declared") sans changer
// où/combien de fois le script est inclus.
if (!window.__productCardSwatchesLoaded) {
  window.__productCardSwatchesLoaded = true;

class ProductCardSwatches {
  constructor() {
    this.init();
  }

  init() {
    console.log('ProductCardSwatches initialisé');
    // Ajouter les event listeners pour les swatches
    document.addEventListener('click', (event) => {
      const swatchInput = event.target.closest('.new-product-card__swatch-input');
      if (swatchInput) {
        console.log('Swatch cliqué:', swatchInput);
        this.handleSwatchClick(swatchInput, event);
      }
    });
  }

  handleSwatchClick(swatchInput, event) {
    console.log('handleSwatchClick appelé');
    // Empêcher la propagation du clic
    event.preventDefault();
    event.stopPropagation();

    const card = swatchInput.closest('.new-product-card');
    if (!card) {
      console.log('Card non trouvée');
      return;
    }

    // Récupérer l'input radio
    const input = swatchInput.querySelector('.swatch-input__input');
    if (!input) {
      console.log('Input non trouvé');
      return;
    }

    // Cocher l'input radio
    input.checked = true;

    // Récupérer les data attributes
    const mediaId = input.getAttribute('data-option-media-id');
    const variantUrl = input.getAttribute('data-connected-product-url');
    const variantId = input.getAttribute('data-variant-id');
    
    console.log('Media ID:', mediaId, 'Variant URL:', variantUrl, 'Variant ID:', variantId);
    
    if (!mediaId) {
      console.log('Media ID manquant');
      return;
    }

    // Plus besoin de l'image principale, on travaille directement avec les slides
    console.log('Traitement des slides directement');

    // Mettre à jour l'image directement via l'ID du média
    this.updateProductImageByMediaId(mediaId, card);

    // Mettre à jour les URLs des liens
    this.updateProductUrls(card, variantUrl);
  }

  updateProductImageByMediaId(mediaId, card) {
    console.log('Mise à jour image pour média ID:', mediaId);
    
    // Trouver la slide correspondante dans les slides préchargées
    const allSlides = card.querySelectorAll('.new-product-card__variant-slide');
    
    console.log('Nombre de slides trouvées:', allSlides.length);
    console.log('IDs des slides:', Array.from(allSlides).map(slide => slide.getAttribute('data-media-id')));
    
    // Masquer toutes les slides
    allSlides.forEach(slide => {
      slide.setAttribute('aria-hidden', 'true');
      slide.style.display = 'none';
    });
    
    // Afficher la slide correspondante
    const targetSlide = card.querySelector(`.new-product-card__variant-slide[data-media-id="${mediaId}"]`);
    
    if (targetSlide) {
      console.log('Slide de variant trouvée:', targetSlide);
      targetSlide.setAttribute('aria-hidden', 'false');
      targetSlide.style.display = 'block';
      console.log('Image mise à jour avec succès via slide');
    } else {
      console.log('Aucune slide préchargée trouvée pour ce média ID:', mediaId);
      // Fallback vers la méthode précédente
      this.updateImageFallback(mediaId, card);
    }
  }

  updateImageFallback(mediaId, card) {
    console.log('Tentative de fallback pour média ID:', mediaId);
    
    // Chercher dans la card s'il y a déjà une image avec ce media ID
    const existingImage = card.querySelector(`img[data-media-id="${mediaId}"]`);
    if (existingImage) {
      console.log('Image existante trouvée, affichage de la slide');
      const slide = existingImage.closest('.new-product-card__variant-slide');
      if (slide) {
        slide.setAttribute('aria-hidden', 'false');
        slide.style.display = 'block';
      }
      return;
    }
    
    // Fallback 2 : Utiliser le bon format Shopify CDN
    console.log('Construction avec format Shopify CDN');
    
    console.log('Aucune image de fallback trouvée');
  }

  updateProductUrls(card, variantUrl) {
    console.log('updateProductUrls appelé avec URL:', variantUrl);
    
    // Mettre à jour l'URL du lien de l'image
    const imageLink = card.querySelector('.new-product-card__image-link');
    if (imageLink && variantUrl) {
      console.log('Mise à jour URL image:', imageLink.href, '->', variantUrl);
      imageLink.href = variantUrl;
    } else {
      console.log('Lien image non trouvé ou URL manquante');
    }

    // Mettre à jour l'URL du lien du titre
    const titleLink = card.querySelector('.new-product-card__title-link');
    if (titleLink && variantUrl) {
      console.log('Mise à jour URL titre:', titleLink.href, '->', variantUrl);
      titleLink.href = variantUrl;
    } else {
      console.log('Lien titre non trouvé ou URL manquante');
    }
  }
}

// Initialiser quand le DOM est prêt
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductCardSwatches();
  });
} else {
  new ProductCardSwatches();
}

} // fin du garde-fou window.__productCardSwatchesLoaded
